// Centralized date formatting — Greek norm (dd/MM/yyyy).
// Backend always stores ISO YYYY-MM-DD; only display is reformatted.

/** Format an ISO date / Date / number → dd/MM/yyyy. Returns '—' for empty/0/null. */
export const fmtDate = (input) => {
  if (!input || input === 0 || input === '0' || input === '0000-00-00') return '—';
  try {
    const d = input instanceof Date ? input : new Date(typeof input === 'string' && input.length === 10 ? `${input}T00:00:00` : input);
    if (Number.isNaN(d.getTime())) return String(input);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yy = d.getFullYear();
    return `${dd}/${mm}/${yy}`;
  } catch {
    return String(input);
  }
};

/** Format as dd/MM/yyyy HH:mm — for timestamps. */
export const fmtDateTime = (input) => {
  if (!input) return '—';
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(d.getTime())) return String(input);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const mn = String(d.getMinutes()).padStart(2, '0');
    return `${dd}/${mm}/${yy} ${hh}:${mn}`;
  } catch {
    return String(input);
  }
};

/** Short label: 'dd MMM yyyy' in Greek if isGr, else English. Useful for cards. */
export const fmtDateShort = (input, isGr = false) => {
  if (!input) return '—';
  const months = isGr
    ? ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μαϊ', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ']
    : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  try {
    const d = input instanceof Date ? input : new Date(typeof input === 'string' && input.length === 10 ? `${input}T00:00:00` : input);
    if (Number.isNaN(d.getTime())) return String(input);
    return `${String(d.getDate()).padStart(2, '0')} ${months[d.getMonth()]} ${d.getFullYear()}`;
  } catch {
    return String(input);
  }
};

/** Range helper: "12/03/2026 → 14/03/2026" (or single day if same). */
export const fmtDateRange = (start, end) => {
  const s = fmtDate(start);
  if (!end || start === end) return s;
  return `${s} → ${fmtDate(end)}`;
};
